import webApi, { baseURL } from "../../WebApi/WebApi";


export const getCurrency = async (name, onSuccess, onFailure) => {
    try {
        const res = await webApi.post(
            `/customer/currency/add-currency`, {
            name: name,
           
        }
        );
        if (res.status === 200) {
            const r = res.data;
            return onSuccess(r);
        } else {
            onFailure("Something Wrong! Please Try again later" + res.data);
        }
    } catch (error) {
        console.log("fdgdf")
    }
};


//LIST CURRENCY 

export const getAllCurrencylist = async (data) => {  
    return await webApi.get(`/customer/currency/list-currency`,
    );
}

//GET ALL CURRENCY DATA FROM ADMIN SIDE
export const getAllCurrencyData = async (data) => {  
    return await webApi.get(`/customer/currency/available-list-currency`,
    );
}

//DELETE CURRENCY
export const deleteCurrency = async (currencyId, onSuccess, onFailure) => {
    try {
        const res = await webApi.post(
            `/customer/currency/delete-currency`, {
                currencyId: currencyId,
           
        }
        );
        if (res.status === 200) {
            const r = res.data;
            return onSuccess(r);
        } else {
            onFailure("Something Wrong! Please Try again later" + res.data);
        }
    } catch (error) {
        console.log("fdgdf")
    }
};

//set default currency
export const setDefaultCurrency = async (currencyId, onSuccess, onFailure)=>{
    try {
        const res = await webApi.post(
            `/customer/currency/set-default-currency`, {
                currencyId: currencyId,
           
        }
        );
        if (res.status === 200) {
            const r = res.data;
            return onSuccess(r);
        } else {
            onFailure("Something Wrong! Please Try again later" + res.data);
        }
    } catch (error) {
        console.log("fdgdf")
    }
}